const HighlightText = ({ text }) => {
  return (
    <span className="bg-blue-50 text-transparent bg-clip-text font-bold">
      {text}
    </span>
  );
};

export default HighlightText;
